import { useState } from "react";
import ConversasList from "./ConversasList";
import ChatView from "./ChatView";

// wrapperClass permite reuso fullscreen (página /instagram/inbox).
const DEFAULT_WRAPPER =
  "flex h-[calc(100vh-280px)] min-h-[400px] bg-base border border-white/[0.06] rounded-lg overflow-hidden";

export default function InboxLayout({ contaId, socket, wrapperClass }) {
  const [selectedConversaId, setSelectedConversaId] = useState(null);

  function handleSelect(id) {
    setSelectedConversaId(id);
  }

  function handleVoltar() {
    setSelectedConversaId(null);
  }

  return (
    <div
      className={wrapperClass || DEFAULT_WRAPPER}
      role="main"
      aria-label="Inbox de conversas Instagram Direct"
    >
      {/* ---- Painel esquerdo (35%) ---- */}
      <section
        className={`flex-shrink-0 w-full md:w-[35%] border-r border-white/[0.06] flex flex-col ${
          selectedConversaId !== null ? "hidden md:flex" : "flex"
        }`}
        aria-label="Lista de conversas"
      >
        <ConversasList
          contaId={contaId}
          onSelect={handleSelect}
          selectedId={selectedConversaId}
          socket={socket}
        />
      </section>

      {/* ---- Painel direito (65%) ---- */}
      <section
        className={`flex-1 flex flex-col min-w-0 ${
          selectedConversaId === null ? "hidden md:flex" : "flex"
        }`}
        aria-label="Visualizador de conversa"
      >
        <ChatView
          contaId={contaId}
          conversaId={selectedConversaId}
          socket={socket}
          onVoltar={selectedConversaId !== null ? handleVoltar : undefined}
        />
      </section>
    </div>
  );
}
